module.exports = __webpack_public_path__ + "media/warranty-claim/photos-wide-angle3-45a60757.png";